module.exports = __webpack_public_path__ + "static/media/Trey Tamaki Resume (December 2018).1f45b0a0.pdf";